import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
// import LoginAsUser from "./views/LoginAsUser.vue";




Vue.use(Router);
let router =  new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/login",
      name: "login",
      component: () =>
          import(/* webpackChunkName: "about" */ "./views/Login.vue")
    },
    {
      path: "/reset-password/:access_token?",
      name: "reset-password",
      component: () =>
          import(/* webpackChunkName: "about" */ "./views/ResetPassword.vue")
    },
    {
      path: "/loginasuser",
      name: "loginasuser",
      component: () =>
          import(/* webpackChunkName: "about" */ "./views/LoginAsUser2.vue")
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/event/:id/:order?",
      name: "event",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Event.vue")
    },
    {
      path: "/eventnew/:id/:order?",
      name: "eventnew",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Event.vue")
    },
    {
      path: "/order/:order",
      name: "order-payment-status",
      meta: { requiresAuth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Order.vue")
    },
    {
      path: "/myregistrations",
      name: "myregistrations",
      meta: { requiresAuth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/MyRegistrations.vue")
    },
    {
      path: "/myregistrations/:id",
      name: "myregistrationsinfo",
      meta: { requiresAuth: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/MyRegistrationsInfo.vue")
    },
    {
      path: "/myregistrations/:id/gpx",
      name: "my-gpx-upload",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "gpx" */ "./views/MyGpxUpload.vue")
    },
    {
      path: "/gpx-tutorial",
      name: "gpx-tutorial",
      component: () =>
        import(/* webpackChunkName: "gpx" */ "./views/GpxTutorial.vue")
    },
    {
      path: "/admin",
      name: "events",
      meta: { requiresAuth: true, admin: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Events.vue")
    },
    {
      path: "/admin/events",
      name: "events",
      meta: { requiresAuth: true, admin: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Events.vue")
    },
    {
      // Lista global de validação foi movida para dentro da prova
      // (/admin/events/:eventid/validar-tracklog). Redireciona bookmarks antigos.
      path: "/admin/gpx",
      redirect: "/admin/events"
    },
    {
      path: "/admin/events/:eventid/validar-tracklog",
      name: "admin-gpx-list",
      meta: { requiresAuth: true, admin: true },
      component: () =>
        import(/* webpackChunkName: "gpx" */ "./views/AdminGpxList.vue")
    },
    {
      path: "/admin/events/:eventid/gpx-config",
      name: "admin-gpx-config",
      meta: { requiresAuth: true, admin: true },
      component: () =>
        import(/* webpackChunkName: "gpx" */ "./views/AdminGpxConfig.vue")
    },
    {
      path: "/admin/events/:eventid/results",
      name: "admin-results",
      meta: { requiresAuth: true, admin: true },
      component: () =>
        import(/* webpackChunkName: "results" */ "./views/AdminResults.vue")
    },
    {
      path: "/admin/gpx/team/:teamId/:competitionId",
      name: "admin-gpx-team",
      meta: { requiresAuth: true, admin: true },
      component: () =>
        import(/* webpackChunkName: "gpx" */ "./views/AdminGpxTeam.vue")
    },
    {
      path: "/admin/gpx/:id",
      name: "admin-gpx-detail",
      meta: { requiresAuth: true, admin: true },
      component: () =>
        import(/* webpackChunkName: "gpx" */ "./views/AdminGpxDetail.vue")
    },
    {
      path: "/admin/events/:eventid/registrations",
      name: "registrations",
      meta: { requiresAuth: true, admin: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Registrations.vue")
    },
    {
      path: "/admin/events/:eventid/cupoms",
      name: "cupoms",
      meta: { requiresAuth: true, admin: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Cupoms.vue")
    },
    {
      path: "/admin/events/:eventid/email",
      name: "email",
      meta: { requiresAuth: true, admin: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/SendEmail.vue")
    },
    {
      path: "/admin/events/:eventid/registrations/:id",
      name: "admin-registrations",
      meta: { requiresAuth: true, admin: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/AdminRegistrationsInfo.vue")
    },
    {
      path: "/contato",
      name: "contato",
      meta: { requiresAuth: true, admin: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Contato.vue")
    },
    {
      path: "/politica-privacidade",
      name: "politica-privacidade",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/PoliticaPrivacidade.vue")
    }
  ]
});


router.beforeEach(async (to, from, next) => {
   //debugger;
    if( to.hash.indexOf("#") === 0 ){
      next( to.hash.replace('#',''))
    }

    //if not initialize app, wait for it
    if( window.$store.getters.userInitialize === false){
        await window.$store.dispatch('getUserFromToken');
    }
   


    // 
    if (to.matched.some(record => record.meta.requiresAuth)) {
      
    //   if (to.matched.some(record => record.meta.admin)) {
    //     if( window.$store.getters.user._admin){
    //       next();
    //     }else{
    //       next({
    //         path: '/login',
    //         query: { redirect: to.fullPath }
    //       })

    //   }
    // }

    if (!window.$store.getters.loggedIn) {
        next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        }
      } else {
        next()
      }
    
    
    next();

})


export default router